import {getInvoicingPeriodDataSource} from '@store/settings/invoicingPeriod/invoicing-period.requests';
import {invoicingPeriodStore} from '@store/settings/invoicingPeriod/invoicing-period.store';

export class InvoicingPeriodQuery {
  store = invoicingPeriodStore;

  invoicingPeriods$ = getInvoicingPeriodDataSource.data$();

}

export const invoicingPeriodQuery = new InvoicingPeriodQuery();
